var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.985 511.985",
    style: {
      enableBackground: "new 0 0 511.985 511.985"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M511.528,309.682c-2.484-42.436-15.155-98.231-37.64-165.838c-0.484-1.421-1.25-2.726-2.25-3.835 l-37.107-40.546c-2.016-2.211-4.875-3.469-7.859-3.469h-42.67c-1.656,0-3.281,0.391-4.766,1.125l-19.078,9.523H151.844 l-19.093-9.523c-1.469-0.734-3.109-1.125-4.765-1.125H85.33c-3,0-5.859,1.258-7.875,3.469l-37.092,40.546 c-1.016,1.109-1.781,2.414-2.25,3.835C15.614,211.451,2.943,267.247,0.458,309.682c-2.156,36.75,3.312,64.498,16.265,82.436 c11.265,15.623,28.093,23.873,48.686,23.873c14.968,0,28.546-6.812,40.374-20.279c8.578-9.781,16.265-23.156,22.828-39.797 c7.187-18.17,11.468-36.17,13.593-46.576h227.579c2.125,10.406,6.406,28.406,13.594,46.576 c6.562,16.641,14.249,30.016,22.826,39.797c11.828,13.467,25.422,20.279,40.375,20.279c20.592,0,37.436-8.25,48.701-23.873 C508.216,374.181,513.684,346.432,511.528,309.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M263.529,259.122c4.171,4.164,4.171,10.922,0,15.094c-4.156,4.156-10.923,4.156-15.079,0 c-4.172-4.172-4.172-10.93,0-15.094C252.606,254.958,259.373,254.958,263.529,259.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M412.875,178.202c-4.172,4.172-10.921,4.172-15.077,0c-4.172-4.164-4.172-10.914,0-15.085 c4.156-4.164,10.905-4.164,15.077,0C417.047,167.289,417.047,174.038,412.875,178.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M412.875,220.873c-4.172,4.164-10.921,4.164-15.077,0c-4.172-4.164-4.172-10.922,0-15.086 c4.156-4.164,10.905-4.164,15.077,0C417.047,209.951,417.047,216.709,412.875,220.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M434.203,199.538c-4.156,4.164-10.906,4.164-15.078,0s-4.172-10.914,0-15.085 c4.172-4.164,10.922-4.164,15.078,0C438.375,188.617,438.375,195.374,434.203,199.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M391.548,199.538c-4.172,4.164-10.921,4.164-15.093,0c-4.156-4.164-4.156-10.914,0-15.085 c4.172-4.164,10.921-4.164,15.093,0C395.704,188.617,395.704,195.374,391.548,199.538z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M223.998,277.341c0,23.561-19.109,42.654-42.67,42.654s-42.67-19.094-42.67-42.654 c0-23.578,19.109-42.679,42.67-42.679S223.998,253.763,223.998,277.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.327,223.998c-29.405,0-53.342,23.921-53.342,53.342c0,29.404,23.937,53.326,53.342,53.326 s53.327-23.922,53.327-53.326C234.654,247.919,210.733,223.998,181.327,223.998z M181.327,309.339 c-17.64,0-31.999-14.375-31.999-31.998c0-17.656,14.359-32.007,31.999-32.007s31.999,14.351,31.999,32.007 C213.326,294.964,198.968,309.339,181.327,309.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M373.33,277.341c0,23.561-19.094,42.654-42.671,42.654c-23.562,0-42.655-19.094-42.655-42.654 c0-23.578,19.094-42.679,42.655-42.679C354.236,234.661,373.33,253.763,373.33,277.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.659,223.998c-29.405,0-53.326,23.921-53.326,53.342c0,29.404,23.921,53.326,53.326,53.326 c29.421,0,53.343-23.922,53.343-53.326C384.002,247.919,360.08,223.998,330.659,223.998z M330.659,309.339 c-17.64,0-31.999-14.375-31.999-31.998c0-17.656,14.359-32.007,31.999-32.007c17.655,0,32.015,14.351,32.015,32.007 C362.674,294.964,348.314,309.339,330.659,309.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F7FA"
    },
    d: "M106.658,223.998c-5.891,0-10.671-4.773-10.671-10.672v-42.663c0-5.89,4.781-10.664,10.671-10.664 s10.671,4.773,10.671,10.664v42.663C117.329,219.225,112.549,223.998,106.658,223.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M127.986,202.663H85.33c-5.89,0-10.671-4.773-10.671-10.664s4.781-10.672,10.671-10.672h42.655 c5.89,0,10.671,4.781,10.671,10.672C138.657,197.889,133.876,202.663,127.986,202.663z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.323,
    y: 106.643,
    style: {
      fill: "#FFCE54"
    },
    width: 149.33,
    height: 42.686
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M495.279,392.118c8.922-12.359,14.28-29.375,16.062-50.779c-0.031,0-59.732,43.545-117.262,36.279 c0,0,0.047,0.406,0.172,1.109c3.75,6.5,7.749,12.172,11.952,16.984c11.828,13.467,25.422,20.279,40.375,20.279 C467.17,415.991,484.014,407.741,495.279,392.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M16.723,392.118c-8.921-12.359-14.296-29.375-16.062-50.779c0,0,59.717,43.545,117.262,36.279 c0,0-0.062,0.406-0.172,1.109c-3.766,6.5-7.75,12.172-11.968,16.984c-11.828,13.467-25.405,20.279-40.374,20.279 C44.816,415.991,27.989,407.741,16.723,392.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M70.878,106.642h80.966l-19.093-9.523c-1.469-0.734-3.109-1.125-4.765-1.125H85.33 c-3,0-5.859,1.258-7.875,3.469L70.878,106.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M441.125,106.642h-80.951l19.078-9.523c1.484-0.734,3.109-1.125,4.766-1.125h42.67 c2.984,0,5.844,1.258,7.859,3.469L441.125,106.642z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4b807e229f22a9330239791ebb7a8e7.svg";
export { ForwardRef as ReactComponent };